import { select, put } from 'redux-saga/effects';

import { fetchUserApi } from 'common/api/users';
import { userSelector } from 'common/selectors';
import { addUserAction } from 'common/actions';

export function* getUserEffect(id) {
  if (id !== -1) {
    const cachedUser = yield select(userSelector(id));

    if (cachedUser) {
      return cachedUser;
    }

    const user = yield fetchUserApi(id);
    yield put(
      addUserAction({
        ...user,
        id,
      })
    );
    return user;
  }
  return null;
}
